
// @ts-nocheck


export const localeCodes =  [
  "sv",
  "en",
  "he",
  "ru",
  "ru-KZ"
]

export const localeLoaders = {
  sv: [
    {
      key: "locale_define_45locale_46ts_0f9c34c2",
      load: () => import("#nuxt-i18n/0f9c34c2" /* webpackChunkName: "locale_define_45locale_46ts_0f9c34c2" */),
      cache: false
    }
  ],
  en: [
    {
      key: "locale_define_45locale_46ts_0f9c34c2",
      load: () => import("#nuxt-i18n/0f9c34c2" /* webpackChunkName: "locale_define_45locale_46ts_0f9c34c2" */),
      cache: false
    }
  ],
  he: [
    {
      key: "locale_define_45locale_46ts_0f9c34c2",
      load: () => import("#nuxt-i18n/0f9c34c2" /* webpackChunkName: "locale_define_45locale_46ts_0f9c34c2" */),
      cache: false
    }
  ],
  ru: [
    {
      key: "locale_define_45locale_46ts_0f9c34c2",
      load: () => import("#nuxt-i18n/0f9c34c2" /* webpackChunkName: "locale_define_45locale_46ts_0f9c34c2" */),
      cache: false
    }
  ],
  "ru-KZ": [
    {
      key: "locale_define_45locale_46ts_0f9c34c2",
      load: () => import("#nuxt-i18n/0f9c34c2" /* webpackChunkName: "locale_define_45locale_46ts_0f9c34c2" */),
      cache: false
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/b36abf9f" /* webpackChunkName: "config_vue_45i18n_46ts_b36abf9f" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "sv",
      language: "sv",
      files: [
        {
          path: "/app/i18n/locales/define-locale.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      language: "en",
      files: [
        {
          path: "/app/i18n/locales/define-locale.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "he",
      language: "he",
      files: [
        {
          path: "/app/i18n/locales/define-locale.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      language: "ru",
      files: [
        {
          path: "/app/i18n/locales/define-locale.ts",
          cache: undefined
        }
      ]
    },
    {
      code: "ru-KZ",
      language: "ru-KZ",
      files: [
        {
          path: "/app/i18n/locales/define-locale.ts",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "ru-KZ",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "./locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "sv",
    language: "sv",
    files: [
      {
        path: "/app/i18n/locales/define-locale.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    language: "en",
    files: [
      {
        path: "/app/i18n/locales/define-locale.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "he",
    language: "he",
    files: [
      {
        path: "/app/i18n/locales/define-locale.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    language: "ru",
    files: [
      {
        path: "/app/i18n/locales/define-locale.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "ru-KZ",
    language: "ru-KZ",
    files: [
      {
        path: "/app/i18n/locales/define-locale.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/